<div class="flow-text-input-wrapper" [style.width.px]="width">
  @if (label) {
    <label class="flow-text-input-label" [for]="fieldId" agText="body-3-medium">{{ label }}</label>
  }

  <div [ngClass]="['flow-text-input', focused ? 'focused' : '', hasValue ? 'typing' : '', showError ? 'error' : '', disabled ? 'disabled' : '', type === 'number' ? 'number' : '']">
    <input
      #field
      [id]="fieldId"
      [type]="inputType"
      [attr.inputmode]="inputMode"
      class="text-field"
      [value]="displayValue"
      [placeholder]="effectivePlaceholder"
      [disabled]="disabled"
      [attr.maxlength]="maxLength"
      (input)="onInput(field.value, field)"
      (keydown)="onKeydown($event, field)"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />

    @if (suffixLabel) {
      <span class="suffix-label" agText="body-3-medium">{{ suffixLabel }}</span>
    }

    @if (showClear) {
      <button type="button" class="clear-button" aria-label="Clear" (click)="onClear()">
        <span class="icon-wrapper" aria-hidden="true">
          <img [src]="iconService.Icon.cross" class="icon" />
        </span>
      </button>
    }

    @if (showRevealToggle) {
      <button type="button" class="reveal-button" [attr.aria-label]="revealed ? 'Hide' : 'Show'" [disabled]="disabled" (click)="toggleReveal()">
        <span class="icon-wrapper" aria-hidden="true">
          <img [src]="revealIcon" class="icon" />
        </span>
      </button>
    }

    @if (showColorBox) {
      <span class="color-box" [style.background-color]="colorBoxColor" aria-hidden="true"></span>
    }

    @if (showClock) {
      <span class="icon-wrapper" aria-hidden="true">
        <img [src]="iconService.Icon.clock" class="icon" />
      </span>
    }
  </div>

  @if (showHelper) {
    <flow-helper-text [helperText]="helperText" [variant]="helperVariant" [characterCount]="characterCount" [maxCount]="maxLength"></flow-helper-text>
  }
</div>
